import { Directive, inject, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthStateService } from '../auth-state.service';

@Directive({ selector: '[appHasPermission]', standalone: true })
export class HasPermissionDirective {
  private authState = inject(AuthStateService);
  private templateRef = inject(TemplateRef<unknown>);
  private viewContainer = inject(ViewContainerRef);

  @Input() set appHasPermission(permission: string | string[]) {
    const perms = Array.isArray(permission) ? permission : [permission];
    const hasAccess = this.authState.hasAnyPermission(perms);
    this.viewContainer.clear();
    if (hasAccess) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
